// extracted by mini-css-extract-plugin
module.exports = {"noBorder":"FunctionalPropertyBanner_noBorder__23zTD"};